var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from './avatar.styles';
export var Avatar = function (_a) {
    var dataUrl = _a.dataUrl, _b = _a.size, size = _b === void 0 ? 'lg' : _b, _c = _a.displayBorder, displayBorder = _c === void 0 ? false : _c, _d = _a.borderColor, borderColor = _d === void 0 ? 'white' : _d, className = _a.className;
    return (_jsx("div", { className: "".concat(styles.avatar(size, displayBorder), " ").concat(className), style: __assign(__assign({}, styles.getImageDimensionsBasedOnSizeType(size, borderColor, dataUrl)), { backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', imageOrientation: 'none' }) }));
};
export default Avatar;
//# sourceMappingURL=avatar.js.map